import * as Sentry from "@sentry/react";

const isLocal = process.env.NODE_ENV === "development";

if (!isLocal) {
  Sentry.init({
    dsn: 'https://327469d27d584fec99cdc676abb2fb6d@o451098.ingest.sentry.io/5436526',
    environment: process.env.NEXT_PUBLIC_STAGE_APP,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      process.env.NEXT_PUBLIC_API_ENDPOINT,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export function logError(error, errorInfo=null) {
  if (isLocal) {
    return;
  }

  Sentry.withScope((scope) => {
    errorInfo && scope.setExtras(errorInfo);
    Sentry.captureException(error);
  });
}

export function onError(error) {
  let errorInfo = {};
  let message = error.toString();

  // Wrap non-Error objects inside an Error.
  if (!(error instanceof Error) && error.message) {
    errorInfo = error;
    message = error.message;
    error = new Error(message);
  // Annotate API errors with the API URL.
  } else if (error?.config?.url) {
    errorInfo.url = error.config.url;
  }

  logError(error, errorInfo);
}
